import { colors } from "@areahub/theme";

/**
 *  Colors determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Riverine_Flooding/FeatureServer/1&source=sd)
 *  */
const RIVERINE_FLOODS_STOPS = [
  -9999,
  colors.blueGray[200],
  0,
  colors.green[300],
  0.9,
  colors.amber[300],
  2.45,
  colors.orange[500],
  4.37,
  colors.red[500],
  7.2,
  colors.red[600],
];

/**
 *  Legend determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Riverine_Flooding/FeatureServer/1&source=sd)
 */
const getLegendRows = () => {
  return [
    ["> 7.2 – 12.6", 11],
    ["> 4.37 – 7.2", 9],
    ["> 2.45 – 4.37", 7],
    ["> 0.9 – 2.45", 5],
    ["0 – 0.9", 3],
    ["Not Applicable", 1],
  ].map((row) => ({
    icon: "draw-polygon",
    label: row[0] === "Not Applicable" ? row[0] : row[0] + " events/yr",
    color: RIVERINE_FLOODS_STOPS[row[1] as number],
  }));
};

export const riverineFloods = {
  stops: RIVERINE_FLOODS_STOPS,
  props: getLegendRows(),
};
